export function parseTraffic (bytesValue: string | number | null | undefined) {
    // Если значение отсутствует, null, undefined
    if (bytesValue === null || bytesValue === undefined) {
        return "Unlimited";
    }

    // Преобразуем в строку и проверяем на валидность
    const stringValue = String(bytesValue);
    
    // Если строка пустая, содержит NaN или не является числом
    if (!stringValue || stringValue === 'null' || stringValue === 'undefined' || stringValue === 'NaN') {
        return "Unlimited";
    }

    const units = ["Б", "КБ", "МБ", "ГБ", "ТБ"];
    let unitIndex = 0;
    let value = parseFloat(stringValue);

    // Если parseFloat вернул NaN или отрицательное число
    if (isNaN(value) || value < 0) {
        return "Unlimited";
    }

    // Если значение равно 0, показываем "0 Б"
    if (value === 0) {
        return "0 Б";
    }

    while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex++;
    }

    return `${value.toFixed(2)} ${units[unitIndex]}`;
}